import { EntityTemplateVariables } from '@tools/interfaces/template';
import { templateOrder } from '@tools/config/template-order-and-order-items';

export const templateTaxCertificate: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.tax_certificates.code.label',
      contentValue: '{{ tax_certificate.code }}',
      description: 'templates.tax_certificates.code.description',
    },
    // Beneficiary data
    {
      label: 'templates.tax_certificates.beneficiary_firstname.label',
      contentValue: '{{ tax_certificate.beneficiary_firstname }}',
      description: 'templates.tax_certificates.beneficiary_firstname.description',
    },
    {
      label: 'templates.tax_certificates.beneficiary_lastname.label',
      contentValue: '{{ tax_certificate.beneficiary_lastname }}',
      description: 'templates.tax_certificates.beneficiary_lastname.description',
    },
    {
      label: 'templates.tax_certificates.beneficiary_fullname.label',
      contentValue: '{{ tax_certificate.beneficiary_fullname }}',
      description: 'templates.tax_certificates.beneficiary_fullname.description',
    },
    {
      label: 'templates.tax_certificates.beneficiary_birthdate.label',
      contentValue: '{{ tax_certificate.beneficiary_birthdate | date("d/m/Y") }}',
      description: 'templates.tax_certificates.beneficiary_birthdate.description',
    },
    {
      label: 'templates.tax_certificates.beneficiary_national_number.label',
      contentValue: '{{ tax_certificate.beneficiary_national_number }}',
      description: 'templates.tax_certificates.beneficiary_national_number.description',
    },
    {
      label: 'templates.tax_certificates.beneficiary_street.label',
      contentValue: '{{ tax_certificate.beneficiary_street }}',
      description: 'templates.tax_certificates.beneficiary_street.description',
    },
    {
      label: 'templates.tax_certificates.beneficiary_street2.label',
      contentValue: '{{ tax_certificate.beneficiary_street2 }}',
      description: 'templates.tax_certificates.beneficiary_street2.description',
    },
    {
      label: 'templates.tax_certificates.beneficiary_zip.label',
      contentValue: '{{ tax_certificate.beneficiary_zip }}',
      description: 'templates.tax_certificates.beneficiary_zip.description',
    },
    {
      label: 'templates.tax_certificates.beneficiary_city.label',
      contentValue: '{{ tax_certificate.beneficiary_city }}',
      description: 'templates.tax_certificates.beneficiary_city.description',
    },
    {
      label: 'templates.tax_certificates.beneficiary_country.label',
      contentValue: '{{ tax_certificate.beneficiary_country }}',
      description: 'templates.tax_certificates.beneficiary_country.description',
    },
    {
      label: 'templates.tax_certificates.beneficiary_address.label',
      contentValue: '{{ tax_certificate.beneficiary_address }}',
      description: 'templates.tax_certificates.beneficiary_address.description',
    },
    // Contact data
    {
      label: 'templates.tax_certificates.contact_firstname.label',
      contentValue: '{{ tax_certificate.contact.contactIndividual.firstname }}',
      description: 'templates.tax_certificates.contact_firstname.description',
    },
    {
      label: 'templates.tax_certificates.contact_lastname.label',
      contentValue: '{{ tax_certificate.contact.contactIndividual.lastname }}',
      description: 'templates.tax_certificates.contact_lastname.description',
    },
    {
      label: 'templates.tax_certificates.contact_fullname.label',
      contentValue: '{{ tax_certificate.contact.fullname }}',
      description: 'templates.tax_certificates.contact_fullname.description',
    },
    {
      label: 'templates.tax_certificates.contact_birthdate.label',
      contentValue: '{{ tax_certificate.contact.contactIndividual.birthdate | date("d/m/Y") }}',
      description: 'templates.tax_certificates.contact_birthdate.description',
    },
    {
      label: 'templates.tax_certificates.contact_national_number.label',
      contentValue: '{{ tax_certificate.contact.contactIndividual.registration_number }}',
      description: 'templates.tax_certificates.contact_national_number.description',
    },
    {
      label: 'templates.tax_certificates.contact_street.label',
      contentValue: '{{ tax_certificate.contact.contactDetail.street }}',
      description: 'templates.tax_certificates.contact_street.description',
    },
    {
      label: 'templates.tax_certificates.contact_street2.label',
      contentValue: '{{ tax_certificate.contact.contactDetail.street2 }}',
      description: 'templates.tax_certificates.contact_street2.description',
    },
    {
      label: 'templates.tax_certificates.contact_zip.label',
      contentValue: '{{ tax_certificate.contact.contactDetail.zip }}',
      description: 'templates.tax_certificates.contact_zip.description',
    },
    {
      label: 'templates.tax_certificates.contact_city.label',
      contentValue: '{{ tax_certificate.contact.contactDetail.city }}',
      description: 'templates.tax_certificates.contact_city.description',
    },
    {
      label: 'templates.tax_certificates.contact_country.label',
      contentValue: '{{ tax_certificate.contact.contactDetail.country }}',
      description: 'templates.tax_certificates.contact_country.description',
    },
    {
      label: 'templates.tax_certificates.contact_address.label',
      contentValue: '{{ tax_certificate.contact.full_address }}',
      description: 'templates.tax_certificates.contact_address.description',
    },
  ],
  related: [],
  relatedInLoop: [
    {
      relationName: 'taxCertificatePeriods',
      relationType: 'inLoop',
      label: 'templates.tax_certificates.tax_certificate_periods.label',
      description: 'templates.tax_certificates.tax_certificate_periods.description',
      blockStartValue: '{% for tax_certificate_period in tax_certificate.taxCertificatePeriods %}',
      contentValue: '{# Add some periods fields #}',
      blockEndValue: '{% endfor %}',
      fields: [
        {
          label: 'templates.tax_certificates.tax_certificate_period.start_date.label',
          contentValue: '{{ tax_certificate_period.start_date | date("d/m/Y") }}',
          description: 'templates.tax_certificates.tax_certificate_period.start_date.description',
        },
        {
          label: 'templates.tax_certificates.tax_certificate_period.end_date.label',
          contentValue: '{{ tax_certificate_period.end_date | date("d/m/Y") }}',
          description: 'templates.tax_certificates.tax_certificate_period.end_date.description',
        },
        {
          label: 'templates.tax_certificates.tax_certificate_period.num_days.label',
          contentValue: '{{ tax_certificate_period.num_days }}',
          description: 'templates.tax_certificates.tax_certificate_period.num_days.description',
        },
        {
          label: 'templates.tax_certificates.tax_certificate_period.price_per_day.label',
          contentValue:
            "{{ tax_certificate_period.price_per_day | format_currency('EUR', {decimal_always_shown: true, fraction_digit: 2}, locale='fr') }}",
          description:
            'templates.tax_certificates.tax_certificate_period.price_per_day.description',
        },
        {
          label: 'templates.tax_certificates.tax_certificate_period.paid_amount.label',
          contentValue:
            "{{ tax_certificate_period.paid_amount | format_currency('EUR', {decimal_always_shown: true, fraction_digit: 2}, locale='fr') }}",
          description: 'templates.tax_certificates.tax_certificate_period.paid_amount.description',
        },
      ],
    },
  ],
};
